// src/pages/About/index.jsx
import React from 'react';
import { Layout, Typography, Card, Row, Col, Timeline, Avatar, Space, Divider } from 'antd';
import { UserOutlined, MailOutlined, GithubOutlined, WechatOutlined, EnvironmentOutlined, CalendarOutlined } from '@ant-design/icons';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import './index.css';

const { Title, Text, Paragraph } = Typography;

const About = ({ loggedInUser, onLogout }) => {
  return (
    <Layout className="blog-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
      <div className="blog-content about-content">
        <div className="about-container">
          <Title level={2} className="about-title">
            关于我们
          </Title>
          
          <Row gutter={[24, 24]}>
            {/* 个人信息卡片 */}
            <Col xs={24} lg={8}>
              <Card className="about-card profile-card">
                <div className="profile-header">
                  <Avatar 
                    size={100} 
                    icon={<UserOutlined />} 
                    className="profile-avatar"
                  />
                  <Title level={3} className="profile-name">
                    zard
                  </Title>
                  <Text type="secondary" className="profile-title">
                    新手菜鸟
                  </Text>
                </div>
                
                <Divider />
                
                <div className="profile-details">
                  <Space direction="vertical" size="middle" className="profile-info">
                    <div className="info-item">
                      <MailOutlined />
                      <Text>zard@qdybgj0621.com</Text>
                    </div>
                    <div className="info-item">
                      <EnvironmentOutlined />
                      <Text>湖北省, 中国</Text>
                    </div>
                    <div className="info-item">
                      <CalendarOutlined />
                      <Text>2025年开始博客创作</Text>
                    </div>
                  </Space>
                </div>
                
                <div className="profile-social">
                  <Space size="large">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <GithubOutlined style={{ fontSize: '24px' }} />
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <WechatOutlined style={{ fontSize: '24px' }} />
                    </a>
                  </Space>
                </div>
              </Card>
            </Col>
            
            {/* 关于博客内容 */}
            <Col xs={24} lg={16}>
              <Card className="about-card content-card">
                <Title level={3}>博客介绍</Title>
                <Paragraph className="about-paragraph">
                  欢迎来到我的技术博客！这是一个分享编程知识、经验和见解的地方。
                  我会在这里记录学习过程中的心得体会，分享实用的技术解决方案，
                  并与大家一起探讨前沿的技术趋势。
                </Paragraph>
                
                <Paragraph className="about-paragraph">
                 作为一名新手菜鸟，我正在努力提升自己的技术能力，
                  并分享自己的学习经验。
                </Paragraph>
                
                <Title level={4} style={{ marginTop: '30px' }}>博客发展历程</Title>
                <Timeline>
                  <Timeline.Item>
                    <Text strong>2025年12月</Text> 正式创建博客，开始记录学习经验。
                  </Timeline.Item>
                </Timeline>
                
                <Title level={4} style={{ marginTop: '30px' }}>技术栈</Title>
                <div className="tech-stack">
                  <Row gutter={[16, 10]}>
                    <Col span={12}>
                      <Text strong>前端:</Text> React, Vue, Angular, HTML/CSS, JavaScript
                    </Col>
                    <Col span={12}>
                      <Text strong>后端:</Text> Node.js, Python, Java, PHP
                    </Col>
                    <Col span={12}>
                      <Text strong>数据库:</Text> MySQL, MongoDB, PostgreSQL
                    </Col>
                    <Col span={12}>
                      <Text strong>运维:</Text> Docker, Nginx, AWS, Linux
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>
          
          {/* 使命和愿景 */}
          <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
            <Col xs={24} md={12}>
              <Card className="about-card mission-card">
                <Title level={4}>我的使命</Title>
                <Paragraph>
                  致力于传播高质量的技术知识，帮助开发者提升技能水平，
                  推动技术创新与发展，构建一个开放、共享的技术社区。
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={12}>
              <Card className="about-card vision-card">
                <Title level={4}>我的愿景</Title>
                <Paragraph>
                  成为最受开发者欢迎的技术博客平台，汇聚全球顶尖技术专家，
                  打造最具影响力的技术内容生态，引领技术发展方向。
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <AppFooter />
    </Layout>
  );
};

export default About;